import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatError, LOGO } from "@/lib/api";
import { StarDivider } from "@/components/common";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("gestioneprivateseals@gmail.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative z-10 min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md boot-in">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO} alt="SEALS Allies Forces" className="w-32 h-32 object-contain drop-shadow-[0_0_30px_rgba(201,162,39,0.4)]" />
          <h1 className="heading text-5xl gold-text mt-4">SEALS</h1>
          <p className="font-rajdhani tracking-[0.35em] text-[var(--silver)] text-xs">ALLIES FORCES</p>
          <p className="font-rajdhani tracking-[0.2em] text-[var(--gold)] text-[10px] mt-2">UNITI. ADDESTRATI. INVINCIBILI.</p>
        </div>

        <div className="panel panel-gold clip-beveled p-8">
          <StarDivider label="Area Riservata" className="mb-6" />
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="font-rajdhani uppercase text-xs tracking-widest text-[var(--silver)]">Email</label>
              <input
                data-testid="login-email"
                type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="w-full mt-1 bg-[#0a0a0a] border border-[var(--steel)]/50 clip-beveled-sm px-4 py-2.5 text-white focus:border-[var(--gold)] focus:outline-none"
              />
            </div>
            <div>
              <label className="font-rajdhani uppercase text-xs tracking-widest text-[var(--silver)]">Password</label>
              <input
                data-testid="login-password"
                type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className="w-full mt-1 bg-[#0a0a0a] border border-[var(--steel)]/50 clip-beveled-sm px-4 py-2.5 text-white focus:border-[var(--gold)] focus:outline-none"
              />
            </div>
            <button data-testid="login-submit" type="submit" disabled={loading}
              className="btn-gold clip-beveled w-full py-3 disabled:opacity-60">
              {loading ? "Accesso..." : "Entra"}
            </button>
          </form>
          <Link to="/seals-of-warzone" data-testid="back-to-site"
            className="mt-6 flex items-center justify-center gap-2 font-rajdhani uppercase tracking-wider text-xs text-[var(--silver)] hover:text-[var(--gold)] transition-colors">
            <ArrowLeft className="w-4 h-4" /> Torna al sito
          </Link>
        </div>
      </div>
    </div>
  );
}
